/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import CurrencySymbol from '../../components/CurrencySymbol';
import LoanAmount from '../../components/LoanAmount';
// import Timestamp from '../../components/Timestamp';

import BOOKING_FEE_PAYMENT_STATUSES from '../../constants/bookingFeePaymentStatuses';

import { centsToFloat } from '../../utils/numbers/centsFloat';
import valueToText from '../../utils/valueToText';
import { vnDepositStatusLabel } from '../../utils/vietnam';
import { namespaces } from '../../constants/translation';

const OfflinePaymentItem = ({
  approvePayment,
  auth,
  handleModalOpen,
  item,
  rejectPayment,
  handleOpenAttachment,
  currentFilter,
  isTablet,
  t,
}) => {
  if (!item.booking) return null;
  const isVATab = currentFilter === 'virtual_account';
  // CPI-974 (D3): Vietnam relabels the deposit statuses; vnDepositStatusLabel is null for MY/ID.
  const statusLabel = vnDepositStatusLabel(auth, t, item.status) ||
    t(valueToText(BOOKING_FEE_PAYMENT_STATUSES, item.status));
  return (
    <Table.Row
      positive={item.status === 'paid'}
      negative={item.status === 'rejected'}
    >
      <Table.Cell width={3}>
        {
          item.status === 'pending_verification' ? (
            <span>
              <Button
                className="large-hide small-hide tablet-hide"
                floated="right"
                color="green"
                onClick={e => approvePayment(e, item.id)}
                size="mini"
                compact
              >
                {t('Approve')}
              </Button>
              <Button
                className="large-hide small-hide tablet-hide"
                floated="right"
                color="red"
                onClick={e => rejectPayment(e, item.id)}
                size="mini"
                compact
              >
                {t('Reject')}
              </Button>
            </span>
          ) : null
        }
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={`/bookings/${item.booking.id}/`}
        >
          {item.booking.projectUnit.reference}
                                      , <br className="large-hide" />
          {item.booking.project.name}
                                      , <br />
          <small>{item.booking.code}</small>
        </a>
      </Table.Cell>
      <Table.Cell>
        {item.booking.customer.customerDetail.name}
      </Table.Cell>
      { isVATab &&
        <Table.Cell className="large-hide small-hide tablet-hide">
          {`${item.transferredToVABank} - ${item.transferredToVAAccountNumber}`}
        </Table.Cell>
      }
      <Table.Cell collapsing>
        <span className="large-hide small-hide tablet-hide" style={{ float: 'right' }}>
          {statusLabel}
        </span>
        <LoanAmount
          format="0,000,000.00"
          amount={centsToFloat(item.amountCents)}
          prefix={<CurrencySymbol />}
        />
        {
          item.paymentPictures && item.paymentPictures.length > 0 ?
            <span>
              &nbsp;
              <button
                className="a-button-blue large-hide small-hide tablet-hide"
                onClick={e => handleOpenAttachment(e, item)}
                title="View Attachments"
              >
                (<b><Icon name="attach" />{item.paymentPictures.length})</b>
              </button>
            </span>
            : ''
        }
      </Table.Cell>
      {/* <Table.Cell collapsing textAlign="right">
        <i>
          <small>
            <span>by </span>
            <Link to={`/users/${item.creatorUserID}/`} >
              {item.requestedName}
            </Link>
            <span className="large-hide small-hide tablet-hide">,&nbsp;</span><br className="mobile-hide" />
            <Timestamp
              timestamp={item.createdAt}
              precise
            />
          </small>
        </i>
      </Table.Cell> */}
      { isVATab &&
        <Table.Cell className="mobile-hide" textAlign="right">
          {`${item.transferredToVABank} - ${item.transferredToVAAccountNumber}`}
        </Table.Cell>
      }
      <Table.Cell
        className="mobile-hide"
        style={{ textTransform: 'capitalize' }}
        collapsing={!(isVATab || isTablet)}
        textAlign="right"
      >
        {statusLabel}
        {
          item.paymentPictures && item.paymentPictures.length > 0 ?
            <span>
              &nbsp;
              <Button
                className="mobile-hide"
                onClick={e => handleOpenAttachment(e, item)}
                compact
                size="mini"
                color="vk"
                title="View Attachments"
              >
                <Icon name="attach" /> {item.paymentPictures.length}
              </Button>
            </span>
            : ''
        }
      </Table.Cell>
      <Table.Cell collapsing={!isTablet} width={2} textAlign="right">
        {
          item.status === 'pending_verification' ? (
            <span>
              <Button className="mobile-hide" color="green" onClick={e => handleModalOpen(e, 'approve', item.id, item.booking)}>{t('Approve')}</Button>
              <Button className="mobile-hide" style={ isTablet ? { marginTop: '10px' } : null } color="red" onClick={e => handleModalOpen(e, 'reject', item.id, item.booking)}>{t('Reject')}</Button>
            </span>
          ) : null
        }
      </Table.Cell>
    </Table.Row>
  );
};

OfflinePaymentItem.propTypes = {
  auth: PropTypes.object,
  item: PropTypes.object,
  approvePayment: PropTypes.func,
  rejectPayment: PropTypes.func,
  handleModalOpen: PropTypes.func,
  handleOpenAttachment: PropTypes.func,
  currentFilter: PropTypes.string,
  isTablet: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation([
  ...namespaces,
])(OfflinePaymentItem);



// WEBPACK FOOTER //
// ./src/containers/Payments/OfflinePaymentItem.jsx